import {HttpLogExporter} from "./HttpLogExporter";
import {joinUrl} from "../Utilities/UriUtilities";
import {LoggerProvider, SimpleLogRecordProcessor} from "@opentelemetry/sdk-logs";

const salesPortalApiDomain = window._env_ && window._env_.REACT_APP_SALES_PORTAL_API_DOMAIN ?
    window._env_.REACT_APP_SALES_PORTAL_API_DOMAIN : process.env.REACT_APP_SALES_PORTAL_API_DOMAIN

const exporter = new HttpLogExporter(joinUrl(salesPortalApiDomain ?? "", "/metrics/opentelemetry/webvitals"));
const logRecordProcessor = new SimpleLogRecordProcessor(exporter)
const loggerProvider = new LoggerProvider({
    resource: undefined,
    processors: [logRecordProcessor]
});

const HISTOGRAM_PAGE_LOAD_LATENCY = loggerProvider.getLogger('salesportal.webapp.page_load_latency');

/**
 * Function will report the page load latency to the backend.
 */
export const reportPageLatency = (metric: any, page: string) => {
    HISTOGRAM_PAGE_LOAD_LATENCY.emit({
        body: '',
        severityNumber: 9,
        severityText: 'INFO',
        attributes: {
            name: metric.name,
            value: metric.value,
            page: page
        }
    });
}
